import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

/**
 * Admin-instelbare app-instellingen (key/value). Nu: max gelijktijdige PDF-parses.
 */
class AppSettingsService extends CustomEventDispatcher {
  constructor() {
    super();
  }

  async getMaxConcurrency() {
    try {
      const response = await api.get('/api/app-settings/pdf-parse-max-concurrency');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async setMaxConcurrency(value) {
    try {
      const response = await api.put('/api/app-settings/pdf-parse-max-concurrency', { value });
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }
}

export default AppSettingsService;
